// extracted by mini-css-extract-plugin
export default {"title":"EvaluationDetails_title__m+sIW"};